import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { ArrowRight, Map } from "lucide-react";
import { getOriginalsStorefrontTeaser } from "@/lib/originals.functions";
import { formatOriginalPrice } from "@/lib/originals";

/**
 * Entrada pública para a loja de rotas prontas. O preço "a partir de" é
 * sempre o menor preço actual das Originais publicadas; sem rotas à venda,
 * o cartão não aparece.
 */
export function StoreEntryCard() {
  const teaserFn = useServerFn(getOriginalsStorefrontTeaser);
  const [teaser, setTeaser] = useState<{
    count: number;
    minPriceCents: number;
    currency: string;
  } | null>(null);

  useEffect(() => {
    let alive = true;
    void teaserFn()
      .then((result) => {
        if (alive) setTeaser(result ?? null);
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, [teaserFn]);

  if (!teaser || teaser.count === 0) return null;

  return (
    <Link
      to="/originals"
      className="flex items-center gap-3 rounded-xl border border-brand/40 bg-brand/5 p-4 transition hover:bg-brand/10"
    >
      <Map className="h-5 w-5 shrink-0 text-brand" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold">Rotas prontas da equipa</p>
        <p className="text-sm text-muted-foreground">
          Roteiros já preparados, disponíveis a partir de{" "}
          {formatOriginalPrice(teaser.minPriceCents, teaser.currency)}.
        </p>
      </div>
      <ArrowRight className="h-4 w-4 shrink-0 text-brand" />
    </Link>
  );
}
